import fieldset from './fieldset';
import configs from '../../configs';

export default {
  title: 'Edit Product',
  elements: [
    {
      type: 'editForm',
      config: {
        actions: {
          fetch: {
            endpoint: 'products/{id}',
            method: 'GET',
            dataPath: 'data'
          },
          save: {
            endpoint: 'products/{id}',
            method: 'PUT'
          }
        },
        fieldsets: [fieldset],
        versionFormView: {
          type: 'editForm',
          versions: configs.versions,
          config: {
            actions: {
              fetch: {
                endpoint: 'products/{id}',
                method: 'GET',
                dataPath: 'data',
                params: {
                  lang: '{versionId}'
                }
              },
              save: {
                endpoint: 'products/{id}',
                method: 'PUT',
                params: {
                  lang: '{versionId}'
                }
              }
            },
            fieldsets: [
              {
                sections: [
                  {
                    title: 'Main attributes',
                    fields: [
                      {
                        label: 'Name',
                        name: 'name'
                      },
                      {
                        label: 'Description',
                        name: 'description',
                        type: 'richText'
                      }
                    ]
                  },
                  {
                    title: 'SEO attributes',
                    fields: [
                      {
                        label: 'Meta title',
                        name: 'meta_title'
                      },
                      {
                        label: 'Meta description',
                        name: 'meta_description',
                        multiline: true
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      }
    }
  ]
};
